









import { Component, Prop, Vue } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import VueRecaptcha from 'vue-recaptcha';

@Component({
  name: 'ReCaptcha',
  components: {
    VueRecaptcha,
  },
})
export default class ReCaptcha extends Vue {
  @Prop({ default: 'normal' }) sizeValue;

  get CaptchaClientSiteKey(): string {
    return vxm.configs.getGlobalConfigValue('RECAPTCHA_CLIENT_SITE_KEY');
  }

  onCaptchaVerified(recaptchaToken) {
    vxm.referrals.getRecaptchaResponse(recaptchaToken);
  }

  mounted() {
    if (!vxm.utility.isVisibleReCaptcha) {
      const invisibleRecaptcha = this.$refs.wlReCaptcha as VueRecaptcha;
      invisibleRecaptcha.execute();
    }
  }
}
